import { cn } from "@/ui/cn";

/** Up to two initials from a name: "Quest Windows" -> "QW", "justin" -> "J". */
export function initials(name: string): string {
  const words = name.trim().split(/\s+/).filter(Boolean);
  return words
    .slice(0, 2)
    .map((w) => w[0]!.toUpperCase())
    .join("");
}

/** A person's or an organization's initials in a tinted square. */
export function Avatar({
  name,
  className,
  shape = "circle",
}: {
  name: string;
  className?: string;
  shape?: "circle" | "square";
}) {
  return (
    <span
      aria-hidden="true"
      className={cn(
        "grid size-8 shrink-0 place-items-center bg-accent-soft text-xs font-semibold text-accent",
        shape === "circle" ? "rounded-full" : "rounded-md",
        className,
      )}
    >
      {initials(name) || "?"}
    </span>
  );
}
